export default __webpack_public_path__ + "static/media/CLICHY (132 sur 176).71a0fe0f.jpg";